import { render, staticRenderFns } from "./SubTwo.vue?vue&type=template&id=c3ce7976&"
import script from "./SubTwo.vue?vue&type=script&lang=js&"
export * from "./SubTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports